import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconVimeo12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconVimeo12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M10.996 3.852q-.067 1.35-2.038 3.697Q6.913 9.999 5.503 10q-.873 0-1.478-1.493L3.218 5.77q-.45-1.493-.964-1.494-.111 0-.783.436L1 4.153q.741-.6 1.458-1.2.99-.79 1.482-.83 1.166-.104 1.436 1.476.29 1.703.4 2.123.338 1.413.74 1.413.316 0 .943-.918.628-.917.673-1.396.09-.791-.673-.792a2 2 0 0 0-.74.152Q7.46 1.94 9.54 2q1.54.044 1.457 1.851"
            />
        </svg>
    );
}
export default memo(IconVimeo12);
